import client, { setSessionActive, isSessionActive } from './client';
import type { AuthResponse, User } from '@/types';

// Même URL utilisée dans fusionauth.ts pour construire la requête d'autorisation
// Le frontend connaît toujours la bonne valeur — window.location.origin est fiable
const REDIRECT_URI =
  import.meta.env.VITE_FUSIONAUTH_REDIRECT_URI ||
  `${window.location.origin}/auth/callback`;

export async function loginWithCallback(code: string): Promise<AuthResponse> {
  // On envoie le redirectUri au backend pour qu'il l'utilise lors de l'échange de token
  // FusionAuth valide lui-même la cohérence — pas besoin de double validation côté back
  const { data } = await client.post<AuthResponse>('/auth/callback', {
    code,
    redirectUri: REDIRECT_URI,
  });
  // Les cookies HttpOnly sont posés par le backend
  // On stocke juste un flag non-sensible pour l'UX
  setSessionActive(true);
  return data;
}

export async function getMe(): Promise<User> {
  const { data } = await client.get<User>('/auth/me');
  return data;
}

export function logout(): void {
  setSessionActive(false);
  // Les cookies seront effacés par le backend via /auth/logout
}

export function isAuthenticated(): boolean {
  return isSessionActive();
}

export const authApi = {
  loginWithCallback,
  getMe,
  logout,
  isAuthenticated,
};

export default authApi;
